import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";
import { DateHelper } from "../helpers/date.helper";

export function invalidMinimumDateValidator(minDate: Date): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        let isInvalid = minDate && control.value && DateHelper.fixDate(control.value) < DateHelper.fixDate(minDate);
        return isInvalid ? { invalidMinimumDate: { value: control.value } } : null;
    };
}